<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper">
            <swiper-slide class="item" v-for="(item,index) in banner" :key="index">
<!--                 <img :src="`http://xilong.sansg.com/${item.picurl}`" alt="">-->
              <div class="bg">

              </div>
                <div class="text">
                    <p class="p1 split">以专业的能力</p>
                    <p class="p2 split">服务全球　奉献社会　共享文明</p>
                  <div class="more">
                    <p>了解更多</p>
                    <img src="../assets/hr.png" alt="">
                  </div>
                </div>
            </swiper-slide>
        </swiper>
         <div class="btn">
           <div class="prev">
             <img src="../assets/hl.png" alt="">
           </div>
           <div class="next">
             <img src="../assets/hr.png" alt="">
           </div>
         </div>
      <div class="swiper-pagination">

      </div>
    </div>
</template>

<script>
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "banner",
        data() {
            return {
                swiperOptiona: {
                    loop: false,
                    init: false,
                    speed: 1600,
                    autoplay:false,
                    delay:5000,
                    navigation: {
                        nextEl: '.btn .next',
                        prevEl: '.btn .prev',
                    },
                    watchSlidesProgress : true,
                    pagination: {
                        el: '.banner .swiper-pagination',
                        clickable: true,
                        type: 'bullets'
                    },
                    on: {
                        init:function(){
                            var p = $(this.slides[this.realIndex]).find(".split");
                            var text = $(this.slides[this.realIndex]).find(".text");
                            text.css({'opacity':'1'})
                            p.textillate('start')
                            p.textillate({ in: { effect: 'fadeInRight' } });
                        },
                        transitionStart:function(){
                            var text = $('.banner .swiper-container').find(".text");
                            text.css({'opacity':'0'})
                        },
                        transitionEnd: function(e){
                            var p = $(this.slides[this.realIndex]).find(".split");
                            var text = $(this.slides[this.realIndex]).find(".text");
                            text.css({'opacity':'1'})
                            p.textillate('start')
                            p.textillate({ in: { effect: 'fadeInRight' } });
                        },
                        setTranslate: function() {
                           var length = $('.swiper-container').find('.swiper-slide').length;
                            for (var n = 0; n < length; n++) {
                                var x = this.slides[1];
                                var  l = 50;
                                var  u = $(x).find(".bg");
                                var r = x.progress* l;
                                r > l && (r = l);
                                r < -l && (r = -l);
                                u.css({"transform": `translate3d(${r}%, 0px, 0px)`});
                            }
                        },
                    },
                }
            }
        },
        props: [
            'banner',
        ],
        components: {
            swiper,
            swiperSlide,
        },
        mounted() {
            this.$nextTick(()=>{
                setTimeout(()=>{
                    this.$refs.mySwipers.swiper.init()
                },500)
                // var p = $('.swiper-container').find(".split");
                // p.textillate({ in: { effect: 'fadeInRight' } });
                // $('.split').textillate({ in: { effect: 'fadeInRight' } });
            })
        }
    }
</script>

<style lang="scss" scoped>
    .banner {
        width: 100%;
        position: relative;
        transition: all 600ms;
        .swiper {
            height: 100vh;
            overflow: hidden;
            .item {
                position: relative;
                overflow: hidden;
                .bg{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                    background-image: url('../assets/banner.png');
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    z-index: 1;
                    cursor: pointer;
                    -webkit-transition: cubic-bezier(.77,0,.175,1) 1.6s transform;
                    -o-transition: cubic-bezier(.77,0,.175,1) 1.6s transform;
                    transition: cubic-bezier(.77,0,.175,1) 1.6s transform;
                }
                .text {
                    position: absolute;
                     left: 20%;
                     top:40%;
                    opacity: 0;
                    transition: ease all .5s;
                     .p1{
                        color:white;
                       font-size: 50px;
                       font-weight: lighter;
                     }
                  .p2{
                    font-size:60px;
                    color:white;
                    font-weight:bold;
                    margin: 30px 0;
                  }

                  .more{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    p{
                      color:white;
                      font-size: 12px;
                    }
                    img{
                      margin-left: 10px;
                    }
                  }
                }
            }
            /*.swiper-slide-active{*/
            /*    .text{*/
            /*        display: block;*/
            /*    }*/
            /*}*/
        }
         .prev{
           position: absolute;
           left:5%;
           top:50%;
           transform: translateY(-50%);
           z-index: 100;
           width: 65px;
           height: 65px;
           border: 1px solid #FFFFFF;
           display: flex;
           align-items: center;
           justify-content: center;
           cursor: pointer;
           border-radius: 50%;
         }
         .next{
        position: absolute;
        right:5%;
        top:50%;
        transform: translateY(-50%);
        z-index: 100;
        width: 65px;
        height: 65px;
        border: 1px solid #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 50%;
      }
        @media screen and (max-width: 1000px) {
        }
    }
</style>
<style scoped>
 .split >>> span{
        opacity: 0;
        transform: translate(50px, 0px);
        transition: 600ms;
     display: inline-block;
    }
 .swiper-slide-active .split >>> span{
     opacity: 1;
     transform: translate(0, 0px);
 }
  .swiper-pagination{
    position: absolute;
    left:0;
    bottom:5%;
    width:100%;
    display: flex;
    justify-content: center;
  }
  .swiper-pagination>>>.swiper-pagination-bullet{
    width: 12px;
    height: 12px;
    background: #FFFFFF;
    opacity: 0.5;
    border-radius: 50%;
    transition: all 600ms;
    margin: 0 5px;
  }
  .swiper-pagination >>> .swiper-pagination-bullet-active{
    width:52px;
    border-radius: 6px;
    background: #C61D1E;
    opacity: 1;
  }
</style>
